import React from 'react';
import PropTypes from 'prop-types';

const AddToCartButton = ({
  id,
  onClick,
  ...props
}) => (
  <button
    id={id}
    onClick={onClick}
    {...props}
  >
      Add to Cart
  </button>
);
AddToCartButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
};
AddToCartButton.defaultProps = {
  id: '',
  className: '',
};

export default AddToCartButton;
